import React from "react"

const LanguageContext = React.createContext({dir:"ltr", language:"de", defaultLanguage:"de"});

export default LanguageContext